// extracted by mini-css-extract-plugin
export var linkText = "_qi-0";